module.exports = __webpack_public_path__ + "img/swiper_right_img.7b32b5b7.png";